// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.etf_edition_switcher {
  display: flex;
  flex-direction: row;
  padding: 5px;
  border-radius: 14px;
  background-color: var(--bg-card);
  border: 1px solid var(--border);
  width: max-content;
  margin: auto;
  margin-bottom: 2rem;
}

.etf_edition_tab {
  padding: 10px 20px;
  border-radius: 10px;
}

.etf_edition_tab {
  cursor: pointer;
}

.etf_edition_tab_select {
  background-color: var(--primary);
  color: white;
}

.etf_edition_tab_not_select {
  background-color: var(--bg);
}`, "",{"version":3,"sources":["webpack://./src/pages/actifs/subpages/EtfEdition/EtfEditionTabs/etfEditionTabs.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".etf_edition_switcher {\n  display: flex;\n  flex-direction: row;\n  padding: 5px;\n  border-radius: 14px;\n  background-color: var(--bg-card);\n  border: 1px solid var(--border);\n  width: max-content;\n  margin: auto;\n  margin-bottom: 2rem;\n}\n\n.etf_edition_tab {\n  padding: 10px 20px;\n  border-radius: 10px;\n}\n\n.etf_edition_tab {\n  cursor: pointer;\n}\n\n.etf_edition_tab_select {\n  background-color: var(--primary);\n  color: white;\n}\n\n.etf_edition_tab_not_select {\n  background-color: var(--bg);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
